import { makeStyles } from '@material-ui/core';
import { condensedStyles } from 'core/components/theme/condensed-layout';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: theme.spacing(0, 'auto'),
    padding: theme.spacing(8)
  },
  sectionWithLine: {
    borderTop: `1px solid ${theme.colorPalette.beige_50_op_70}`,
    marginTop: theme.spacing(5),
    paddingTop: 25
  },
  paymentBlock: {
    paddingBottom: 25
  },
  secondaryPhoneContainer: {
    border: `3px solid ${theme.colorPalette.white}`,
    borderRadius: 3,
    padding: '10px 0px 10px 20px',
    margin: '15px 0px',
    // Reskin: a beige inset panel; a white border can't frame anything on the new look's white card.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  textCheckbox: {
    marginLeft: '5px'
  },
  loanOfficerField: {
    marginTop: theme.spacing(4)
  },
  paymentMethodInfo: {
    padding: theme.spacing(8)
  },
  billToOtherInfoCard: {
    marginBottom: theme.spacing(4)
  },
  paymentMethodTitle: {
    marginBottom: theme.spacing(6)
  },
  paymentInformation: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colorPalette.green_100
  },
  infoIcon: {
    marginRight: theme.spacing(1)
  }
});

export default makeStyles(styles);
